import Vue from "vue";

import DateTime from "vue-datetime/src";
// import "vue-datetime/dist/vue-datetime.css";
import { Settings, DateTime as LuxonDateTime } from "luxon";

Settings.defaultLocale = "id";
Settings.defaultZoneName = "Asia/Jakarta";

window.LuxonDateTime = LuxonDateTime;

Vue.use(DateTime);
